export * from './sidebar.directive';



// WEBPACK FOOTER //
// /var/www/midac/midac-live/app/src/app/directives/sidebar/index.ts